module.exports = __webpack_public_path__ + "img/zuantou.prt.d39045e1.jpg";